import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import useTreeEditor from '../../../../../../../../hooks/useTreeEditor';
import styles from './EditGoalHierarchyForm.module.scss';
import APIClient from '../../../../../../../../util/APIClient';
import FormAlert from '../../../../../../Common/FormAlert/FormAlert';

export default function EditGoalHierarchyForm() {
  const { teamId } = useParams();
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [formAlert, setFormAlert] = React.useState(null);
  const { getGoalHierarchies, hasError } = useTreeEditor();
  const navigate = useNavigate();

  const handleSave = async () => {
    setIsSubmitting(true);
    try {
      await APIClient.put(`user/teams/${teamId}/goals/hierarchy`, getGoalHierarchies());
      setFormAlert({
        severity: 'success',
        title: 'Goal hierarchy updated successfully!',
        message: 'Goal hierarchy has been updated successfully. You will be redirected shortly.',
      });
      setTimeout(() => {
        navigate(`/user/teams/${teamId}/goals/hierarchy`);
      }, 3000);
    } catch {
      setFormAlert({
        severity: 'error',
        title: 'Could not update goal hierarchy!',
        message:
          'Something went wrong when updating goal hierarchy. Please contact the administrator for further support.',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.editGoalHierarchyForm}>
      <LoadingButton
        loading={isSubmitting}
        onClick={handleSave}
        variant="contained"
        disabled={hasError}
        startIcon={<SaveOutlinedIcon />}
      >
        Update Goal Hierarchy
      </LoadingButton>
      {formAlert && <FormAlert alert={formAlert} />}
    </div>
  );
}
